const Marquee = ({ items, dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y ${
      dark ? "border-white/10 bg-ink text-white/60" : "border-ink/10 bg-white text-ink/60"
    }`}
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max items-center py-5 font-mono text-[11px] uppercase tracking-[0.4em]">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center whitespace-nowrap">
              {item}
              <span className="mx-10 text-accent">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
